export function menu() {
  const button = document.querySelector(".header-bottom__nav-link-main");
  const menu = document.querySelector(".header-bottom__nav-link-main-dropdown");

  button.addEventListener("click", (el) => {
    el.preventDefault();
    button.classList.toggle("active");
    menu.classList.toggle("active");
  });

  document.addEventListener("click", (el) => {
    const containsMenu = el.composedPath().includes(menu);
    const containsButton = el.composedPath().includes(button);

    if (!containsMenu && !containsButton) {
      button.classList.remove("active");
      menu.classList.remove("active");
    }
  });
}
